import {
  MatchTeamContainer,
  OrgName,
  TeamScore,
  OrgLogoContainer,
} from "./styles";
import { selectRosterDisplayTrigram } from "selectors/Roster";
import { Match } from "model/Match/Match";
import { isPlaceholderRosterId } from "model/Roster/Roster";
import { getRosterDisplayScore } from "model/Match/MatchScore";
import { RosterOrgLogo } from "components/Logo/RosterOrgLogo";
import { useAppSelector } from "app/hooks";

interface Props {
  match: Match;
  rosterId: string;
  tournamentId: string;
  showScore: boolean;
}

export const MatchTeam = ({
  match,
  rosterId,
  tournamentId,
  showScore,
}: Props) => {
  const displayName = useAppSelector((state) =>
    selectRosterDisplayTrigram(state, rosterId, tournamentId)
  );

  const isPlaceholder = isPlaceholderRosterId(rosterId);

  return (
    <MatchTeamContainer>
      <OrgLogoContainer>
        {!isPlaceholder && (
          <RosterOrgLogo rosterId={rosterId} tournamentId={tournamentId} />
        )}
      </OrgLogoContainer>
      <OrgName>{displayName ?? ""}</OrgName>
      {showScore && !isPlaceholder && (
        <TeamScore>{getRosterDisplayScore(match, rosterId)}</TeamScore>
      )}
    </MatchTeamContainer>
  );
};
